import React, { useEffect, createRef, useState } from "react"
import CModal from "../elements/c_modal"
import DfbRte from "../ui-kit/dfb_rte"

const MModalInfo = (props) => {

  const COOKIE_NAME = "info_modal";
  const COOKIE_DAYS_ALIVE = 14;
  const MODAL_TIMEOUT_SECONDS = 5
  const modalRef = createRef();

  const [timeoutPassed, setTimeoutPassed] = useState(false)
  const [hasScrolled, setHasScrolled] = useState(false)

  const openModal = () => {
    const cookieMaxAge = COOKIE_DAYS_ALIVE * 24 * 60 * 60
    const cookieExists = document.cookie.split(";").some((item) => {
      return item.trim().startsWith(`${COOKIE_NAME}=`)
    })

    if (!cookieExists) {
      document.cookie = `${COOKIE_NAME}=true; path=/; max-age=${cookieMaxAge}`

      if (modalRef.current?.dfbModal) {
        modalRef.current.dfbModal.open()
      }
    }
  }

  useEffect(() => {

    window.addEventListener("scroll", () => {
      setHasScrolled(true)
    })

    setTimeout(() => {
      setTimeoutPassed(true)
    }, MODAL_TIMEOUT_SECONDS * 1000)


    return () => {
      setHasScrolled(false)
      setTimeoutPassed(false)
    }
  }, [])

  useEffect(() => {
    if ((timeoutPassed && !hasScrolled) || (hasScrolled && !timeoutPassed)) {
      openModal()
    }
  }, [timeoutPassed, hasScrolled])

  return props.data.text ? (
    <CModal
      ref={modalRef}
      add_class="dfb-Modal--fullsizePhone m-ModalInfo-modal"
      id="infoModal"
      autoOpen={false}
    >
      <div className="m-ModalInfo">
        <DfbRte text={props.data.text} />
      </div>
    </CModal>
  ) : null
}

export default MModalInfo
